export const addClass = (element: HTMLElement, className: string | string[]) => {
  const classList = element.classList;

  typeof className === 'string'
    ? classList.add(className)
    : className.forEach(name => classList.add(name));
};
